import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class AuctionAccessBlacklistsList extends Component {
  render() {
    const { onSelectAuctionAccessBlacklist, auctionAccessBlackLists } = this.props;
    const listRow = ListRow(onSelectAuctionAccessBlacklist);

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>Auction Access Number</Table.HeaderCell>
        <Table.HeaderCell>Expiration Date</Table.HeaderCell>
        <Table.HeaderCell>Notes</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Created At</Table.HeaderCell>
        <Table.HeaderCell />
      </Table.Row>
    );

    return (
      <div>
        <Header>Auction Access Blacklist</Header>
        <div>
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={auctionAccessBlackLists}
            headerRow={headerRow}
            size='tiny'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
          />
        </div>
      </div>
    );
  }
}

AuctionAccessBlacklistsList.propTypes = {
  onSelectAuctionAccessBlacklist: PropTypes.func,
  auctionAccessBlackLists: PropTypes.arrayOf(PropTypes.object),
};

AuctionAccessBlacklistsList.defaultProps = {
  onSelectAuctionAccessBlacklist: () => {},
  auctionAccessBlackLists: [],
};

export default compose(withApollo, withRouter)(AuctionAccessBlacklistsList);
